import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/stores/auth.store'

// Masaüstü (onprem tek kullanıcı) için daha uzun boşta-kalma süresi; web 10 dk kalır.
const isTauri = typeof window !== 'undefined' && !!(window as { __TAURI__?: unknown }).__TAURI__
const IDLE_MS = (isTauri ? 30 : 10) * 60 * 1000 // hareketsizlik süresi

const ACTIVITY_EVENTS = [
  'mousemove', 'mousedown', 'keydown',
  'touchstart', 'scroll', 'click', 'wheel',
]

export function useIdleLogout() {
  const { isAuthenticated, logout } = useAuthStore()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (!isAuthenticated) return

    function resetTimer() {
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        try {
          const w = window as { __TAURI__?: unknown }
          if (w.__TAURI__) {
            import('@tauri-apps/api/core')
              .then(({ invoke }) => invoke('frontend_log', { msg: `OTURUM KAPANDI (idle ${IDLE_MS / 60000}dk hareketsizlik)` }).catch(() => {}))
              .catch(() => {})
          }
        } catch { /* ignore */ }
        logout()
        window.location.href = '/login'
      }, IDLE_MS)
    }

    // İlk sayfa yükünde timer'ı başlat
    resetTimer()

    // Kullanıcı aktivitelerinde timer'ı sıfırla
    ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, resetTimer, { passive: true }))

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      ACTIVITY_EVENTS.forEach((ev) => window.removeEventListener(ev, resetTimer))
    }
  }, [isAuthenticated, logout])
}
